import IconFont from './iconFont';

export default IconFont;
